var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Tooltip } from '@material-ui/core';
import { mdiCircleOutline, mdiCheckCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import styled, { ThemeContext } from 'styled-components';
import { IconSize } from '../../../lib';
import { defaultMuiTheme } from '../../../styles/MaterialTheme';
import inProgressIconPath from './inProgressIcon';
export { inProgressIconPath };
const StyledIcon = styled(Icon) `
    width: ${IconSize.Small};
    height: ${IconSize.Small};

    ${defaultMuiTheme.breakpoints.up('sm')} {
        width: ${IconSize.Medium};
        height: ${IconSize.Medium};
    }
`;
export var ProgressIndicatorStatus;
(function (ProgressIndicatorStatus) {
    ProgressIndicatorStatus["NotStarted"] = "Not Started";
    ProgressIndicatorStatus["InProgress"] = "In Progress";
    ProgressIndicatorStatus["Complete"] = "Complete";
})(ProgressIndicatorStatus || (ProgressIndicatorStatus = {}));
export const progressStateToStatus = (progressState) => {
    if (progressState === 0) {
        return ProgressIndicatorStatus.NotStarted;
    }
    if (progressState > 0 && progressState < 1) {
        return ProgressIndicatorStatus.InProgress;
    }
    return ProgressIndicatorStatus.Complete;
};
const ProgressIndicator = (_a) => {
    var { progressStatus = ProgressIndicatorStatus.NotStarted, tooltipTitle } = _a, otherProps = __rest(_a, ["progressStatus", "tooltipTitle"]);
    const theme = useContext(ThemeContext);
    const commonIconProps = {
        'aria-label': progressStatus
    };
    const renderProgressIndicatorIcon = () => {
        switch (progressStatus) {
            case ProgressIndicatorStatus.NotStarted:
            default:
                return (React.createElement(StyledIcon, Object.assign({ color: theme.colors.textTertiary, path: mdiCircleOutline }, commonIconProps, otherProps)));
            case ProgressIndicatorStatus.InProgress:
                return (React.createElement(StyledIcon, Object.assign({ color: theme.colors.primaryLighter, path: inProgressIconPath }, commonIconProps, otherProps)));
            case ProgressIndicatorStatus.Complete:
                return (React.createElement(StyledIcon, Object.assign({ color: theme.colors.success, path: mdiCheckCircleOutline }, commonIconProps, otherProps)));
        }
    };
    return React.createElement(Tooltip, { title: tooltipTitle !== null && tooltipTitle !== void 0 ? tooltipTitle : progressStatus }, renderProgressIndicatorIcon());
};
export default ProgressIndicator;
//# sourceMappingURL=index.js.map